import Vue from "vue";
import {
  Archive,
  Banknote,
  Bitcoin,
  Lock,
  Mail,
  UserCheck,
  Users,
  Trash2,
  // ... otros iconos que necesites
} from "lucide-vue";

// Registra todos los iconos que uses frecuentemente
const icons = {
  Archive,
  Banknote,
  Bitcoin,
  Lock,
  Mail,
  UserCheck,
  Users,
  Trash2,
}

Object.entries(icons).forEach(([name, component]) => {
  Vue.component(name, component)
});
